'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Apollo = require('@apollo/client');
var ReturnsConfigProvider = require('./ReturnsConfigProvider.js');
var auth = require('../utils/auth.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ReturnsContext = /*#__PURE__*/React.createContext(undefined);
const createClient = _ref => {
  let {
    returnsHeadlessUrl,
    localeCountry,
    localeLanguage,
    moniker,
    token
  } = _ref;
  return new Apollo.ApolloClient({
    defaultOptions: {
      query: {
        fetchPolicy: 'network-only'
      }
    },
    cache: new Apollo.InMemoryCache({
      addTypename: false
    }),
    link: new Apollo.HttpLink({
      uri: returnsHeadlessUrl,
      headers: {
        'narvar-returns-locale': `${localeLanguage}_${localeCountry}`,
        'narvar-returns-retailer-moniker': moniker,
        ...(token ? {
          Authorization: `Bearer ${token}`
        } : undefined)
      }
    })
  });
};
const ReturnsProvider = _ref2 => {
  let {
    children
  } = _ref2;
  const {
    localeCountry,
    localeLanguage,
    moniker,
    returnsHeadlessUrl,
    prefill,
    overrideCode,
    token,
    getToken
  } = ReturnsConfigProvider.useReturnsConfig();
  const [submittedReturn, setSubmittedReturn] = React.useState();
  const [client, setClient] = React.useState(token ? createClient({
    localeCountry,
    localeLanguage,
    moniker,
    returnsHeadlessUrl,
    token
  }) : undefined);
  const [orderData, setOrderData] = React.useState();
  const [selectedItems, setSelectedItems] = React.useState([]);
  const [returnCart, setReturnCart] = React.useState();
  const [userRole, setUserRole] = React.useState(auth.UserRoles.UNKNOWN);
  const [selectedPudoOption, setSelectedPudoOption] = React.useState();
  const [submittedReturnsForOrder, setSubmittedReturnsForOrder] = React.useState();
  const initAuthenticatedClient = React.useCallback(async _ref3 => {
    let {
      orderId,
      email,
      overrideCode,
      token
    } = _ref3;
    const clientConfig = {
      returnsHeadlessUrl,
      localeCountry,
      localeLanguage,
      moniker,
      token
    };

    // If there is no pre-seeded token from CSR Login, we use getToken to fetch a token and set it in the clientConfig.
    if (!token && orderId && email) {
      const res = await (getToken === null || getToken === void 0 ? void 0 : getToken({
        order: orderId,
        email,
        locale: `${localeLanguage}_${localeCountry}`,
        retailer: moniker,
        ...(overrideCode ? {
          overrideCode
        } : {})
      }));
      clientConfig.token = res === null || res === void 0 ? void 0 : res.accessToken;
    }
    const newClient = createClient(clientConfig);
    setClient(newClient);
    setUserRole(auth.getUserRole(moniker, clientConfig.token));
    return newClient;
  }, [getToken, localeLanguage, localeCountry, moniker, returnsHeadlessUrl]);
  const initUnauthenticatedClient = React.useCallback(() => {
    const newClient = createClient({
      returnsHeadlessUrl,
      localeCountry,
      localeLanguage,
      moniker
    });
    setClient(newClient);
    return newClient;
  }, [localeLanguage, localeCountry, moniker, returnsHeadlessUrl]);
  const value = React.useMemo(() => ({
    client,
    orderData,
    selectedItems,
    submittedReturn,
    setSubmittedReturn,
    setOrderData,
    setSelectedItems,
    localeCountry,
    localeLanguage,
    moniker,
    prefill,
    overrideCode,
    returnCart,
    setReturnCart,
    selectedPudoOption,
    setSelectedPudoOption,
    initUnauthenticatedClient,
    initAuthenticatedClient,
    submittedReturnsForOrder,
    setSubmittedReturnsForOrder,
    userRole
  }), [client, orderData, selectedItems, submittedReturn, setSubmittedReturn, setOrderData, setSelectedItems, localeCountry, localeLanguage, moniker, prefill, overrideCode, returnCart, setReturnCart, selectedPudoOption, setSelectedPudoOption, initUnauthenticatedClient, initAuthenticatedClient, submittedReturnsForOrder, setSubmittedReturnsForOrder, userRole]);
  return /*#__PURE__*/React__default["default"].createElement(ReturnsContext.Provider, {
    value: value
  }, children);
};

exports.ReturnsContext = ReturnsContext;
exports["default"] = ReturnsProvider;
